import React from 'react';
import Layout from '../components/Layout';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../components/ui/card";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";
import { Mail, MapPin } from 'lucide-react';
import { toast } from "sonner";

const ContactFR = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    toast.success("Message envoyé !", {
      description: "Merci de nous avoir contactés. Nous reviendrons vers vous rapidement."
    });
  };

  return (
    <Layout>
      <section className="py-20 bg-slate-50 min-h-[calc(100vh-64px)]">
        <div className="container mx-auto px-4 md:px-6">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-16">
              <h1 className="text-4xl font-bold text-slate-900 mb-4">Contactez-nous</h1>
              <p className="text-xl text-slate-600">
                Vous souhaitez recruter les meilleurs talents français ? Nous serions ravis d'échanger avec vous.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
              <Card className="border-none shadow-md h-full">
                <CardContent className="p-6 flex flex-col items-center text-center gap-4">
                  <div className="bg-red-100 p-4 rounded-full">
                    <Mail className="h-8 w-8 text-red-600" />
                  </div>
                  <div>
                    <h3 className="font-bold text-slate-900 text-lg">Envoyez-nous un email</h3>
                    <p className="text-slate-600 mt-2">contact@internjin.com</p>
                  </div>
                </CardContent>
              </Card>

              <div className="bg-slate-900 text-white p-8 rounded-xl shadow-md flex flex-col justify-center items-center text-center h-full">
                <h3 className="font-bold text-xl mb-4">Startup Pré-seed</h3>
                <p className="text-slate-300 leading-relaxed">
                  Nous sommes actuellement à nos débuts et construisons des partenariats solides avec des entreprises sélectionnées.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default ContactFR;
